export default __webpack_public_path__ + "static/media/slide5.112d68d6.jpg";